import { WishlistModule } from '../'
import { registerModule } from '@vue-storefront/core/lib/modules';

export const IsOnWishlist = {
  name: 'isOnWishlist',
  props: {
    product: {
      required: true,
      type: Object
    }
  },
  created () {
    registerModule(WishlistModule)
  },
  computed: {
    isOnWishlist () {
      return this.$store.getters['wishlist/isOnWishlist'](this.product)
    }
  }
}
